import GameSprint from "./GameSprint";

export default GameSprint;
